import React from 'react';
import PropTypes from 'prop-types';
import PhoneIcon from '@material-ui/icons/Phone';
import { StyledHighlights, StyledHighlightIcon, StyledLink, StyledText } from './styles';


const PhoneNumber = ({ phoneNumber }) => (
  <StyledHighlights>
    <ul>
      <li>
        <StyledHighlightIcon phone>
          <PhoneIcon />
        </StyledHighlightIcon>
        <div>
          <StyledText>
            Call&nbsp;
            <StyledLink href={`tel:${phoneNumber}`}>{phoneNumber}</StyledLink>
            &nbsp;for Free Expert Help
          </StyledText>
        </div>
      </li>
    </ul>
  </StyledHighlights>
);

PhoneNumber.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
};

export default PhoneNumber;
